export const SSO_ERROR_STORAGE_KEY = 'app:sso:error';

export const MESSAGES = {
  DISCOVER_INVALID_AUTH: 'Invalid authorization or challenge parameters',
  INVALID_GRANT: 'Sign-in link expired or already used. Enter your email and try again.',
  INVALID_CLIENT: 'Sign-in is temporarily unavailable. Try again later or contact support.',
  SESSION_EXPIRED: 'Sign-in session expired. Enter your email and try again.',
  GENERIC_EXCHANGE: 'Sign-in failed. Please try again.',
  GENERIC_DISCOVER: 'Unable to continue. Please check your email and try again.',
};

const isDiscoverInvalidAuthError = (message = '') => (
  message === MESSAGES.DISCOVER_INVALID_AUTH
  || message.includes('Invalid authorization or challenge parameters')
);

export const getDiscoverErrorMessage = (err) => {
  const message = typeof err === 'string' ? err : err?.message;

  if (isDiscoverInvalidAuthError(message)) {
    return MESSAGES.DISCOVER_INVALID_AUTH;
  }

  if (message) {
    return message;
  }

  return MESSAGES.GENERIC_DISCOVER;
};

const resolveOAuthErrorCode = (body = {}, message = '') => {
  const code = body.code || body.error;

  if (code === 'invalid_grant' || message === 'invalid_grant' || body.error === 'invalid_grant') {
    return 'invalid_grant';
  }

  if (code === 'invalid_client' || message === 'invalid_client' || body.error === 'invalid_client') {
    return 'invalid_client';
  }

  return null;
};

export const getExchangeErrorMessage = (err) => {
  const body = err?.body || {};
  const message = typeof err === 'string' ? err : err?.message;
  const oauthCode = resolveOAuthErrorCode(body, message);

  if (oauthCode === 'invalid_grant') {
    return MESSAGES.INVALID_GRANT;
  }

  if (oauthCode === 'invalid_client') {
    return MESSAGES.INVALID_CLIENT;
  }

  if (message && message !== 'Request failed') {
    return message;
  }

  return MESSAGES.GENERIC_EXCHANGE;
};

export const getMissingClientIdMessage = () => MESSAGES.SESSION_EXPIRED;
